import { useEffect, useState } from "react";
import Aurora from "@/components/Aurora/Aurora";
import OathboundNav from "@/components/OathboundNav/OathboundNav";
import "./OathboundFrame.css";

const MOBILE_QUERY = "(max-width: 767px)";
const desktopAuroraColors = ["#f6efc1", "#e8c35d", "#aa803b", "#5e421f"];

// Repeating the first stop preserves the four-stop shader while presenting
// only three unique, darker colors on small screens.
const mobileAuroraColors = ["#c0943d", "#c0943d", "#aa803b", "#5e421f"];
const desktopAuroraMotion = { amplitude: 2, blend: 0.75, speed: 0.55 };

// A smaller, narrower, slower wave prevents the Aurora from overpowering
// content or appearing rushed in a narrow mobile viewport.
const mobileAuroraMotion = { amplitude: 0.85, blend: 0.52, speed: 0.24 };

function useMediaQuery(query) {
  const [matches, setMatches] = useState(
    () => window.matchMedia(query).matches,
  );

  useEffect(() => {
    const mediaQuery = window.matchMedia(query);
    const handleChange = (event) => setMatches(event.matches);
    setMatches(mediaQuery.matches);
    mediaQuery.addEventListener?.("change", handleChange);
    return () => mediaQuery.removeEventListener?.("change", handleChange);
  }, [query]);

  return matches;
}

/**
 * Keeps the branded navigation and Aurora identical across the landing and
 * purchase routes while React swaps only the page content beneath them.
 */
export default function OathboundFrame() {
  const isMobile = useMediaQuery(MOBILE_QUERY);
  const auroraMotion = isMobile ? mobileAuroraMotion : desktopAuroraMotion;

  return (
    <>
      <div className="oathbound-aurora" aria-hidden="true">
        <Aurora
          colorStops={isMobile ? mobileAuroraColors : desktopAuroraColors}
          amplitude={auroraMotion.amplitude}
          blend={auroraMotion.blend}
          speed={auroraMotion.speed}
          maxDpr={isMobile ? 1 : 1.5}
        />
      </div>
      <OathboundNav />
    </>
  );
}
